/** 온보딩 화면의 경로. 여기 한 곳에서만 적는다 — 화면마다 적으면 하나가 뒤처진다. */
const ONBOARDING_PATH = '/onboarding';

/**
 * 로그인 직후 내려앉을 곳.
 *
 * **온보딩을 안 지난 사람은 그 화면을 먼저 거친다.** 온보딩에는 「건너뛰기」가 없다 —
 * 닉네임·업무·경험 세 값이 다 있어야 소분방 배정과 자료 추천이 돌아가고, 하나라도
 * 비면 그 회원은 어느 축에도 못 들어가 결국 아무것도 못 받는다.
 *
 * 지금까지 온보딩은 **소셜 가입에서만** 닿았다. 이메일로 가입한 사람은 그 화면을
 * 아예 못 봤고, 그래서 마이페이지 닉네임이 이메일 아이디로 남아 있었다.
 *
 * 원래 가려던 곳은 `next` 로 물고 간다. 온보딩이 끝나면 그리로 이어진다 —
 * 자료를 받으러 온 사람을 자료 앞이 아니라 자료실 첫 화면에 떨어뜨리면
 * 그 사람은 방금 왜 로그인했는지를 다시 찾아야 한다.
 */
export function signinLanding(next: string, isOnboarded: boolean): string {
  return isOnboarded ? next : `${ONBOARDING_PATH}?next=${encodeURIComponent(next)}`;
}

/**
 * 운영자가 로그인했을 때 운영자 화면으로 곧장 보낼지 판정한다.
 *
 * 보내지 **않는** 두 경우가 있다.
 *
 * 1. 주소에 `next` 가 명시된 경우 — 자료를 받으려다 게이트에 막혀 로그인한 사람이
 *    운영자이기도 할 수 있다. 그 사람이 원한 것은 자료지 운영자 화면이 아니다.
 * 2. 운영자가 아닌 경우 — 당연하지만, 역할은 서버가 준 값만 믿는다.
 *
 * 온보딩은 건너뛴다. 온보딩은 소분방 배정과 자료 추천을 위한 것이라 운영자 계정에는
 * 해당이 없고, 거기서 막으면 운영자가 자기 화면에 못 들어간다.
 */
export function isAdminLanding(role: string, hasExplicitNext: boolean): boolean {
  return role === 'ADMIN' && !hasExplicitNext;
}
